import { render, staticRenderFns } from "./optionsCom.vue?vue&type=template&id=69af485d&scoped=true"
import script from "./optionsCom.vue?vue&type=script&lang=js"
export * from "./optionsCom.vue?vue&type=script&lang=js"
import style0 from "./optionsCom.vue?vue&type=style&index=0&id=69af485d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69af485d",
  null
  
)

export default component.exports